import { useState, useEffect } from "react";
import CourseCard from "../../components/courseCard/courseCard";
import { fetchStudentTest } from "../../api/utils";

const Landing = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [testList, setTestList] = useState([]);
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const testList = await fetchStudentTest();
      if (testList.status) {
        const data = testList.data;
        setTestList(data.test_list);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="course-container-home container my-5">
      {isLoading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="row mb-3">
            <span className="head-text text-grey h1">
              Enrolled{" "}
              <span className="text-center text-secondary-main">Tests</span>
            </span>
          </div>

          <div className="row row-cols-1 row-cols-md-3 gy-5">
            <CourseCard data={testList} />
          </div>
        </>
      )}
    </div>
  );
};

export default Landing;
